import axios from "axios";

export function apiGetVisualmanagements(instance) {
  return axios
    .get(process.env.REACT_APP_URL_EXPRESS + "api/visualmanagements/", {
      headers: {
        instance: instance,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiSaveVisualmanagement(instance, formData) {
  return axios
    .post(process.env.REACT_APP_URL_EXPRESS + "api/visualmanagements", formData, {
      headers: {
        instance: instance,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiUpdateVisualmanagement(idVisualmanagement, formData) {
  return axios
    .put(
      process.env.REACT_APP_URL_EXPRESS + "api/visualmanagements/" + idVisualmanagement,
      formData
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiDeleteVisualmanagement(idVisualmanagement) {
  return axios
    .delete(process.env.REACT_APP_URL_EXPRESS + "api/visualmanagements/" + idVisualmanagement)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}
